import {useState} from "react";
import BrandLogo from "../../../utils/brands/BrandLogo.jsx";

export default function CreateIntegrationPlatform({brand, onClick}) {
    return <div className={
        'comp__roundedBox block select-none shadow cursor-pointer max-w-24 min-w-24 bg-white hover:bg-slate-50 dark:bg-slate-800 dark:hover:bg-slate-950 rounded pt-4 pb-2'
    } onClick={onClick}>
        <BrandLogo brand={brand}
            className={'mx-auto'}
            size={'10'}
        />
        <div className={'flex w-full mt-2 h-12'}>
            <div className={'m-auto text-center px-3'}>{brand['name']}</div>
        </div>
    </div>;
}
